import { useEffect } from 'react';
import { usePersonalization } from '@/contexts/PersonalizationContext';

export function useAccessibility() {
  const { preferences } = usePersonalization();

  useEffect(() => {
    if (!preferences?.accessibility_settings) return;

    const root = document.documentElement;
    const settings = preferences.accessibility_settings;

    // Apply font size
    if (settings.fontSize) {
      root.setAttribute('data-font-size', settings.fontSize);
    }

    // Apply high contrast
    if (settings.highContrast !== undefined) {
      root.setAttribute('data-high-contrast', settings.highContrast.toString());
    }

    // Apply reduced motion
    if (settings.reducedMotion !== undefined) {
      root.setAttribute('data-reduced-motion', settings.reducedMotion.toString());
    }
  }, [preferences?.accessibility_settings]);

  return {
    fontSize: preferences?.accessibility_settings?.fontSize || 'medium',
    highContrast: preferences?.accessibility_settings?.highContrast || false,
    reducedMotion: preferences?.accessibility_settings?.reducedMotion || false,
  };
}
